(() => {
  function playVideo(button) {
    const videoUrl = button.getAttribute('data-video-url');
    if (!videoUrl) return;

    const container = button.closest('.madesa-projetos__hero-video-container') || button.parentElement;
    if (!container) return;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', videoUrl);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.className = 'madesa-projetos__hero-video-iframe';

    container.innerHTML = '';
    container.appendChild(iframe);
  }

  function init() {
    const buttons = Array.from(document.querySelectorAll('.madesa-projetos-page-hero .madesa-projetos__hero-play-button'));
    buttons.forEach((button) => {
      button.addEventListener('click', () => playVideo(button));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
